var NProgress = require('nprogresscustom');

module.exports = function(){
	NProgress.done();
};